export type InvoiceType = 'internal' | 'fiscal';

export type InvoiceStatus =
  | 'draft'
  | 'pending'
  | 'issued'
  | 'cancelled'
  | 'error';

export type Invoice = {
  id: string;
  companyId: string;
  commercialOperationId: string | null;
  clientId: string | null;
  type: InvoiceType;
  status: InvoiceStatus;
  invoiceNumber: string;
  issueDate: string;
  dueDate: string;
  subtotal: number;
  taxes: number;
  total: number;
  currency: string;
  notes: string;
  arcaStatus: string;
  arcaCAE: string;
  arcaCAEExpiration: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type InvoiceInput = {
  commercialOperationId: string | null;
  clientId: string | null;
  type: InvoiceType;
  status: InvoiceStatus;
  issueDate: string;
  dueDate: string;
  subtotal: number;
  taxes: number;
  total: number;
  currency: string;
  notes: string;
};

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  internal: 'Interna',
  fiscal: 'Fiscal (ARCA)',
};

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  draft: 'Borrador',
  pending: 'Pendiente',
  issued: 'Emitida',
  cancelled: 'Cancelada',
  error: 'Error',
};

/** Estados editables en UI (factura interna). */
export const EDITABLE_INVOICE_STATUSES: readonly InvoiceStatus[] = [
  'draft',
  'pending',
  'issued',
  'cancelled',
  'error',
] as const;
